/**
 * Icone wallet SVG (prototype v7.2.1) — TOUJOURS ce SVG, jamais l'emoji 👛
 * (regle prompt v7.2.1 §0.A). Utilisee par la pastille header, la carte
 * « Mon wallet » du Compte et la page Wallet.
 */
function WalletIcon({ size = 15, color = 'rgb(var(--c-green))' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, display: 'block' }}>
      <rect x="2.5" y="5.5" width="19" height="14" rx="3" stroke={color} strokeWidth="1.8" />
      <path d="M2.5 9.5h19" stroke={color} strokeWidth="1.8" />
      <circle cx="16.5" cy="14.5" r="1.4" fill={color} />
    </svg>
  )
}

export default WalletIcon
